import { app } from '../../../../bootstrap/core';
import progressBarComponent from './progressBar.component';

app.component('statusProgressBar', progressBarComponent);



// WEBPACK FOOTER //
// ./src/app/components/status/components/progressBar/progressBar.js